import axios from '@/utils/axios'

export const state = {
  auth: false,
  npo: '',
  registration: '',
  mouvement: '',
  pilot: false,
  lastBreath: new Date()
}

export const getters = {
  isAuthenticated: (state) => state.auth,
  isGuest: (state) => !state.auth,
  // Comparing milliseconds, 2h = 60min * 10sec * 100ms
  isDead: (state) => new Date - new Date(state.lastBreath) > (2*60*60*100),
  isPilot: (state) => state.pilot
}

export const mutations = {
  login(state, {npo, registration, mouvement, pilot}) {
    state.auth = true
    state.npo = npo
    state.registration = registration
    state.mouvement = mouvement
    state.pilot = pilot
  },
  logout(state) {
    state.auth = false
    state.npo = ''
    state.registration = ''
    state.mouvement = ''
    state.pilot = false
  },
  breathe(state) {
    state.lastBreath = new Date()
  }
}

export const actions = {
  async login({commit}, {url, npo, registration}) {
    try {
      // TODO axios
      const response = await axios.post(url, {
        npo,
        registration
      })
      if(response.status !== 200) throw response.statusText
      commit('login', {
        npo,
        registration,
        mouvement: response.data.mouvement,
        pilot: response.data.pilot
      })
    } catch(err) {
      return err
    }
  },
  async logout({commit}) {
    commit('logout')
    return {
      res: true,
      err: null
    }
  },
  breathe({commit}) {
    commit('breathe')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
